import React from "react";
import { Spin } from "antd";
import Backdrop from "../../asserts/CRMbg.png";
import "../../App.css";

const Loader = () => {
  return (
    <div
      className={`h-screen w-screen px-[2.5vw]`}
      style={{
        backgroundImage: `url(${Backdrop})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute top-[50vh] left-[50vw] flex justify-center items-center  z-10 col-span-6">
                    <Spin size="large" />
                  </div>
    </div>
  );
};

export default Loader;
